module.exports = __webpack_public_path__ + "img/spotify_logo_RGB_green.11dc437a.png";